import * as React from "react";
import { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import CssBaseline from "@mui/material/CssBaseline";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import MyAppBar from "../AppBar";
import { Container } from "@mui/system";
import AppBottomNavigation from "../AppBottomNavigation";
import RightMenu from "../RightMenu";
import Box from "@mui/material/Box";

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
  palette: {
    mode: "dark",
    primary: {
      main: "#fff5ff",
      // background: {
      //   default: "#2e2d2b",
      //   paper: "#2e2d2b",
      // },
    },

    background: {
      default: "#5b2074",
    },
    text: {
      primary: "#fff5ff",
    },
  },
  typography: {
    fontFamily: "IRANSansXFaNum",
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#5b2074",
          color: "#fff5ff",
        },
      },
    },
    // MuiBottomNavigation: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "#2e2d2b",
    //       "& .muirtl-yzareb-MuiPaper-root": {
    //         backgroundColor: "#2e2d2b",
    //       },
    //     },
    //     "& .muirtl-yzareb-MuiPaper-root": {
    //       backgroundColor: "#2e2d2b",
    //     },
    //   },
    // },
  },
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const Layout = ({
  children,
  mobileNumber,
  NameFamily,
  handleComToShow,
  arrowBackEnable,
  handleBack,
}) => {
  const [showRightMenu, setShowRightMenu] = useState(false);

  const handleRightMenu = () => {
    setShowRightMenu(true);
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setShowRightMenu(open);
  };
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div dir="rtl">
          <MyAppBar
            handleRightMenu={handleRightMenu}
            arrowBackEnable={arrowBackEnable}
            handleBack={handleBack}
          />
          <RightMenu
            showActive={showRightMenu}
            mobileNumber={mobileNumber}
            NameFamily={NameFamily}
            toggleDrawer={toggleDrawer}
            handleComToShow={handleComToShow}
          />
          <Container>
            <Box sx={{ pb: 12, pt: 10 }}>
              {children}
              <AppBottomNavigation
                handleRightMenu={handleRightMenu}
                handleComToShow={handleComToShow}
              />
            </Box>
          </Container>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
};
export default Layout;
